/**
 * WithingsOverviewPage - Route-Komponente für Overview Tab
 * Wrapper um OverviewTab mit Router-Integration
 */

import React from "react";

import { useWithingsData } from "../../hooks/useWithingsData";
import { OverviewTab } from "./OverviewTab";

export const WithingsOverviewPage: React.FC = () => {
  const { dateRange, isLoadingMeasurements, measurements, setDateRange } = useWithingsData();

  return (
    <OverviewTab
      dateRange={dateRange}
      isLoading={isLoadingMeasurements}
      measurements={measurements}
      onDateRangeChange={setDateRange}
    />
  );
};
